import { useRef } from 'react';

export default () => {
  return useRef(window);
};
